import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PaymentTransactionType } from '../../../types/Finance';

const initialState:PaymentTransactionType = {
  idStudent: '',
  idPaymentType: '',
  date: '',
  amountPaid: 0,
  paymentProof: ''

}

const paymentTransactionSlice = createSlice({
  name: "paymentTransaction",
  initialState,
  reducers: {
    setPaymentTransactionData:(state, action:PayloadAction<PaymentTransactionType>)=>({...state, ...action.payload}), 
    setPaymentsTransactionsData:(
      state, action:PayloadAction<PaymentTransactionType[]>
    ) =>
      {
        state.transactions = action.payload
      }, 
    resetPaymentTransactionData :()=>({...initialState})
  }
});

export const {setPaymentTransactionData,resetPaymentTransactionData,setPaymentsTransactionsData} = paymentTransactionSlice.actions

export default paymentTransactionSlice.reducer